import { render, staticRenderFns } from "./exam-answer-feedback.vue?vue&type=template&id=11ce861c&scoped=true"
import script from "./exam-answer-feedback.vue?vue&type=script&lang=js"
export * from "./exam-answer-feedback.vue?vue&type=script&lang=js"
import style0 from "./exam-answer-feedback.vue?vue&type=style&index=0&id=11ce861c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11ce861c",
  null
  
)

export default component.exports